import Modal from '../modal/Modal';
import appleMaps from '../../assets/navigation/appleMapas.svg';
import googleMaps from '../../assets/navigation/googleMaps.svg';
import waze from '../../assets/navigation/waze.svg';
import './ToastMapsOptions.css';
interface Props {
  isModalOpen: boolean;
  allowButtonClosed: boolean;
  setShowToastMapsOptions: (vaue: boolean) => void;
  googleMapsUrl: string;
  appleMapsUrl: string;
  wazeUrl: string;
}

const ToastMapsOptions: React.FC<Props> = ({
  isModalOpen,
  setShowToastMapsOptions,
  allowButtonClosed,
  googleMapsUrl,
  appleMapsUrl,
  wazeUrl,
}) => {
  return (
    <>
      <Modal
        allowButtonClosed={allowButtonClosed}
        isOpen={isModalOpen}
        onClose={() => setShowToastMapsOptions(false)}
        title='Escolha o app para navegação'
      >
        <div className='apps-maps-container'>
          <div className='apps-maps-content'>
            <a
              className='apps-maps-img-container'
              rel='noopener noreferrer'
              href={appleMapsUrl}
              target='_blank'
            >
              <img alt='apple-maps' src={appleMaps} />
            </a>
            Apple Maps
          </div>
          <div className='apps-maps-content'>
            <a
              className='apps-maps-img-container'
              rel='noopener noreferrer'
              href={googleMapsUrl}
              target='_blank'
            >
              <img alt='google-maps' src={googleMaps} />
            </a>
            Google Maps
          </div>
          <div className='apps-maps-content'>
            <a
              className='apps-maps-img-container'
              rel='noopener noreferrer'
              href={wazeUrl}
              target='_blank'
            >
              <img alt='waze-maps' src={waze} />
            </a>
            Waze
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ToastMapsOptions;
